(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('avantris-slideshow-layout')) {
    customElements.define('avantris-slideshow-layout', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
      setup() {
        this.carousel = this.querySelector('slideshow-element');
        this.words = this.querySelector('slideshow-words');
        if (!this.carousel || !this.words) return;
        this.syncAccessibility();
        this.mutations = new MutationObserver(() => this.syncAccessibility());
        this.mutations.observe(this.words, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
        this.resize = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => { if (this.isConnected) this.carousel.slider?.resize(); });
        });
        this.resize.observe(this);
      }
      syncAccessibility() {
        this.words.querySelectorAll('.slideshow-word').forEach((slide) => {
          const inactive = slide.getAttribute('aria-current') !== 'true';
          slide.inert = inactive;
          slide.setAttribute('aria-hidden', String(inactive));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.resizeFrame);
        this.mutations?.disconnect();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
